import { Box, CircularProgress } from "@mui/material";
import Text from "./Text";

const Loader = ({ text,height }) => {
    return (<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height:height }}>
        <CircularProgress color="primary" />
        <Text text={text ? text : "Loading..."} style={{ marginLeft: 32 }}/>
    </Box>)
}
export default Loader;